import React from 'react';

import ReduxConnect from 'Demora/redux-connect';

import classnames from 'classnames';

import { Popover, PopoverBody } from 'reactstrap';

import Awards from './award_funcs';

class ShowAward extends React.Component {
	constructor() {
		super();

		this.state = {
			v: (Math.random() + '').split('.')[1],
			popoverOpen: false,
		};
	}

	toggle = () => {
		this.setState({
			popoverOpen: !this.state.popoverOpen,
		});
	};

	render() {
		const props = this.props;

		const state = this.state;

		const u = props.users[props.obj];

		if (!u || !u.current_award) {
			return null;
		}

		const x = 0;

		const aw = u.current_award;

		const c = Awards.getColourOfAward(u.current_award);

		const icon = aw == 16 ? 'far fa-gem' : 'fas fa-trophy';

		return (
			<div
				className={classnames('ml-1 d-inline-block text-center')}
				id={'Popover1' + state.v}
				onMouseEnter={this.toggle}
				onMouseLeave={this.toggle}
			>
				<i
					className={classnames(icon)}
					style={{
						color: c,
						fontSize: props.iconHeight + 'px',
						verticalAlign: 'top',
					}}
				/>

				<Popover
					placement='top'
					isOpen={state.popoverOpen}
					target={'Popover1' + state.v}
					toggle={this.toggle}
				>
					<PopoverBody>{Awards.getName(aw)} member</PopoverBody>
				</Popover>
			</div>
		);
	}
}

export default ReduxConnect(ShowAward, {
	users: 'users',
});
